import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { X } from 'lucide-react';
import toast from 'react-hot-toast';
import { bankAPI } from '../lib/api';

const SKR03_DEFAULT_BANK = '1200';
const SKR04_DEFAULT_BANK = '1800';

export default function BankKontoFormModal({ open, onClose, slug, skrVariant, onSaved }) {
  const [iban, setIban] = useState('');
  const [name, setName] = useState('');
  const [sachkonto, setSachkonto] = useState(skrVariant === 'SKR04' ? SKR04_DEFAULT_BANK : SKR03_DEFAULT_BANK);
  const [busy, setBusy] = useState(false);

  const reset = () => {
    setIban(''); setName('');
    setSachkonto(skrVariant === 'SKR04' ? SKR04_DEFAULT_BANK : SKR03_DEFAULT_BANK);
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await bankAPI.createKonto(slug, { iban, name, sachkonto, waehrung: 'EUR' });
      toast.success('Bank-Konto angelegt');
      reset();
      onSaved && onSaved();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Anlegen fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={onClose} className="modal-overlay">
        <Transition.Child as={Fragment}
          enter="fade-enter" enterFrom="fade-enter-from" enterTo="fade-enter-to"
          leave="fade-leave" leaveFrom="fade-leave-from" leaveTo="fade-leave-to">
          <div className="modal-backdrop" aria-hidden="true" />
        </Transition.Child>
        <div className="modal-positioner">
          <Transition.Child as={Fragment}
            enter="slide-enter" enterFrom="slide-enter-from" enterTo="slide-enter-to"
            leave="slide-leave" leaveFrom="slide-leave-from" leaveTo="slide-leave-to">
            <Dialog.Panel className="modal-panel" style={{ width: 440 }}>
              <form onSubmit={submit}>
                <div className="modal-header">
                  <Dialog.Title className="modal-title">Neues Bank-Konto</Dialog.Title>
                  <button type="button" className="btn-text" onClick={onClose}><X size={16} /></button>
                </div>

                <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: 12 }}>
                  <label>
                    Bezeichnung *
                    <input
                      type="text" value={name} required maxLength={80}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="z.B. Sparkasse Geschäftskonto"
                    />
                  </label>
                  <label>
                    IBAN *
                    <input
                      type="text" value={iban} required
                      onChange={(e) => setIban(e.target.value)}
                      placeholder="DE89 3704 ..."
                    />
                  </label>
                  <label>
                    Sachkonto (FiBu) *
                    <input
                      type="text" value={sachkonto} required
                      pattern="\d{3,8}"
                      onChange={(e) => setSachkonto(e.target.value)}
                    />
                    <span className="muted small">
                      {skrVariant === 'SKR04' ? 'SKR04 Standard: 1800 (Bank)' : 'SKR03 Standard: 1200 (Bank)'}
                    </span>
                  </label>
                </div>

                <div className="actions" style={{ borderTop: 'none', paddingTop: 12 }}>
                  <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>Abbrechen</button>
                  <button type="submit" className="btn-primary" disabled={busy}>
                    {busy ? 'Speichert…' : 'Anlegen'}
                  </button>
                </div>
              </form>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
